import { useCallback, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'

import { useAtendimento } from '@/features/atendimento/hooks'
import { SimulacaoContent } from '@/features/simulador/brasil/components'
import { Page } from '@/layouts/page'
import { storageKeys } from '@/utils/constants'

export const SimulacaoPage = () => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation('simulacao')
  const navigate = useNavigate()
  const { atendimento, handleIniciarAtendimento } = useAtendimento()

  const _handleIniciarAtendimento = useCallback(
    async (clienteId: string) => {
      if (!atendimento?.id) await handleIniciarAtendimento(clienteId)
    },
    [atendimento?.id, handleIniciarAtendimento],
  )
  const value = useMemo(
    () => ({
      tipo: 'Fetch' as const,
      simulacaoId: id ?? '',
      handleIniciarAtendimento: _handleIniciarAtendimento,
    }),
    [_handleIniciarAtendimento, id],
  )

  return (
    <Page
      className="bg-foreground"
      breadcrumb={[
        { to: '/historico/simulacoes', label: t('pages.simulacao.breadcrumb.historico') },
        { label: t('pages.simulacao.breadcrumb.simulacao_salva') },
      ]}
    >
      <SimulacaoContent.Provider value={value}>
        <SimulacaoContent.Header
          onDuplicarSimulacao={(simulacaoDuplicada) => {
            sessionStorage.removeItem(storageKeys.simulador_form)
            navigate('/simulador', {
              state: {
                empreendimento: simulacaoDuplicada.empreendimento,
                idExternoBloco: simulacaoDuplicada.bloco.idExterno,
                idExternoProduto: simulacaoDuplicada.produto.idExterno,
                tipoDoProduto: simulacaoDuplicada.produto.tipoDoProduto,
                simulacaoDuplicada,
              },
            })
          }}
        />
        <SimulacaoContent.EmpreendimentoSection />
        <SimulacaoContent.ValoresSimuladosSection />
      </SimulacaoContent.Provider>
    </Page>
  )
}
